import Pagination from "@/components/share/pagination";
import Service from "../../../../utils/api/service";
import Helper from "../../../../utils/global/func";
import TableLoading from "../../../../components/share/table-loading";
import NoItem from "./../../../../components/share/table-no-item";
import { mapState } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _debounce from "lodash.debounce";
import Multiselect from "vue-multiselect";

export default {
  name: "ListOrder",
  data() {
    return {
      isFetching: true,
      isNoData: false,
      data: {
        order: [],
        orderStatus: this.$master?.orderStatuses || [],
        pagination: {
          limit: 10,
          page: 1,
          total: 0,
          totalPage: 0,
        },
      },
      search: {
        accountId: "",
        transactionNumber: "",
        invoiceNumber: "",
        orderStatusId: "",
        paymentStatus: "",
        cardCode: "",
        dateRange: "",
        customerGroupId: "",
        provider: "",
        branchIds: "",
      },
      customerGroups: this.$master?.customerGroups || [],
      providers: this.$provider.orderProviderEnum,

      // filter warehouse
      branchs:
        (this.$store?.state?.accountInfo?.branches && [
          { id: "", name: "All Permission Branches" },
          ...this.$store?.state?.accountInfo?.branches,
        ]) ||
        [],
      allBranchs:
        (this.$store?.state?.accountInfo?.branches && [
          { id: "", name: "All Permission Branches" },
          ...this.$store?.state?.accountInfo?.branches,
        ]) ||
        [],
      debouncedOnSearchBranchs: null,
      branchId: "",
      errorMessage: "",
    };
  },
  components: {
    Pagination,
    TableLoading,
    NoItem,
    DatePicker,
    Multiselect,
  },
  created() {
    this.setParams();
    this.getAllOrder();
    this.debouncedOnSearchBranchs = _debounce(
      this.handleBranchSearchChange,
      500
    );
  },
  watch: {
    "$route.fullPath": function () {
      this.setParams();
      this.getAllOrder();
    },
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {},
  methods: {
    setParams() {
      const query = this.$route.query;
      this.search = this.$helper.setParams(this.search, query);

      if (query.startDate && query.endDate) {
        this.search.dateRange = [query.startDate, query.endDate];
      } else {
        this.search.dateRange = [];
      }
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    handleBranchSearchChange(query) {
      if (!query || query.trim() === "") {
        this.branchs = [...this.allBranchs];
        return;
      }

      this.filterBranch(this.allBranchs, query);
    },

    filterBranch(data, search) {
      if (!search || search.trim() === "") {
        this.branchs = data;
        return;
      }

      const normalizedSearch = search.toLowerCase().trim();

      const items = data.filter((item) => {
        const matchName = item.name?.toLowerCase().includes(normalizedSearch);
        const matchCode = item.code?.toLowerCase().includes(normalizedSearch);

        return matchName || matchCode;
      });

      this.branchs = items;
    },

    onBranchSelected() {
      this.getAllOrder();
    },

    onSelectProvider(item) {
      if (item === this.search.provider) return;

      this.search.provider = item;
      this.searching();
    },

    getProviderEnum(providers, providerId) {
      return providers.find((item) => item.id === providerId);
    },

    async searching() {
      let query = this.$helper.filterKeyMapping({
        limit: 10,
        page: 1,
        ...this.search,
      });
      await this.$router.push({ query }).catch(() => {});
    },

    getAllOrder() {
      this.isFetching = true;
      let query = this.$root.$route.query;
      let setQuery = this.$helper.filterKeyMapping({
        page: query?.page || 1,
        ...query,
      });
      delete setQuery.branchIds;
      let params = this.$helper.queryParam(setQuery);
      let branchIds = this.search?.branchIds
        ? [this.search?.branchIds]
        : this.$store?.state?.accountInfo?.branches?.map((item) => item?.id) ||
          [];
      let queryString = branchIds
        .filter(Boolean)
        .map((id) => `branchIds=${id}`)
        .join("&");
      params = `${params}&${queryString}`;

      Service.getAllOrder(params).then((response) => {
        this.isFetching = false;

        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getAllOrder();
              }
            });
          } else if (response?.statusCode === "403") {
            this.isNoData = true;
            this.data.order = [];
            this.$toasted.show(response?.message);
          } else {
            this.$toasted.show(response?.message);
            this.errorMessage = response?.message || "No Data";
            this.data.order = [];
            this.isNoData = true;
            this.resetPagination();
          }
        } else {
          if (response.data && response.data.length > 0) {
            this.isNoData = false;
            this.data.order = response?.data;
            this.data.pagination = Helper.calculatePagination(response?.meta);
          } else {
            this.data.order = [];
            this.isNoData = true;
            this.resetPagination();
          }
        }
      });
    },

    viewOrder(id) {
      let object = {
        id: id?.id,
        page: this.$root.$route.query.page,
        accountId: this.search.accountId,
        transactionNumber: this.search.transactionNumber,
        invoiceNumber: this.search.invoiceNumber,
        branchId: id?.branchId,
      };
      if (this.search.accountId == "") {
        delete object.accountId;
      }
      if (this.search.transactionNumber == "") {
        delete object.transactionNumber;
      }
      if (this.search.invoiceNumber == "") {
        delete object.invoiceNumber;
      }
      this.$router.push({ name: "EditOrder", query: object });
    },

    resetPagination() {
      this.data.pagination = {
        limit: 10,
        page: 1,
        total: 0,
        totalPage: 0,
      };
    },

    getFullImage(path) {
      return Helper.getFullImage(path);
    },
  },
};
